import { useState, useEffect } from 'react';
import { BACKEND_DOMAIN } from '../config/variables';
import { GET } from '../utils/axios.util';

const useOrganization = () => {

    const [ organization, setOrganization ] = useState({});

    useEffect(() => {

        // First try to get organization data from coordinator profile
        let payload = {
            url : `${BACKEND_DOMAIN}/coordinator/profile`
        }

        GET(payload).then(res => {
            const { data } = res.data
            if (data?.organization) {
                setOrganization(data.organization)
            } else if (data?.organization_type) {
                // If profile has organization_type directly
                setOrganization({ organization_type: data.organization_type })
            } else {
                // Fallback: try authenticate endpoint
                getOrgFromAuth()
            }
        }).catch(err => {
            getOrgFromAuth()
        })

    }, [])

    const getOrgFromAuth = () => {
        let payload = {
            url : `${BACKEND_DOMAIN}/login/authenticate`
        }

        GET(payload).then(res => {
            const { data } = res.data
            // Check if user data includes organization info
            if (data?.organization) {
                setOrganization(data.organization)
            } else if (data?.organization_type) {
                setOrganization({ organization_type: data.organization_type })
            } else if (data?.institute_id) {
                // If only institute_id is available, we need backend to provide organization_type
                // For now, set a default or try to map institute_id
                setOrganization({ organization_type: mapInstituteToOrgType(data.institute_id) })
            } else {
                setOrganization({})
            }
        }).catch(err => {
            setOrganization({})
        })
    }

    // Temporary mapping function - this should be handled by backend
    const mapInstituteToOrgType = (instituteId) => {
        // This is a temporary solution - backend should provide organization_type
        // For example: institute_id 52 might be a school (type 3) or company (other)
        // You need to determine the correct mapping
        const schoolInstituteIds = [/* list of institute IDs that are schools */]
        return schoolInstituteIds.includes(instituteId) ? 3 : 1 // Default to non-school
    }

    return organization;

}

export default useOrganization